import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { connect } from 'react-redux';
import VendorSalesSourcing from './components/VendorSalesSourcing';
import { SellerSelect } from '../../../shared/prop-types/MainProps';

const VendorSalesSourcingPage = ({ sellerSelect }) => {
  if (sellerSelect.type === 2) {
    return (
      <Container className="dashboard">
        <Row>
          <Col md={12}>
            <h3 className="page-title">Vendor Sales Sourcing</h3>
          </Col>
        </Row>
        <Row>
          <VendorSalesSourcing />
        </Row>
      </Container>
    );
  }
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <p>This is a Vendor specific report. Please select a new report or select a Vendor account.</p>
        </Col>
      </Row>
    </Container>
  );
};

VendorSalesSourcingPage.propTypes = {
  sellerSelect: SellerSelect.isRequired,
};

const mapStateToProps = (state) => {
  const { sellerSelect } = state;

  return {
    sellerSelect,
  };
};

export default connect(mapStateToProps)(VendorSalesSourcingPage);
